/**
 * The line the live channel writes when a socket it did not close closes [0348] — moved out of `liveSocket.ts`
 * unchanged (03-us-kad-6j-i review round 1), so the channel file stays the socket and its end ledger.
 */
import { KIOSK_FRAME_REFUSED } from './liveSocket.contract';

/** The longest close reason logged. The gateway's reasons are its own constant strings, well under this. */
const MAX_LOGGED_REASON = 64;

/**
 * ⭐ **A close the kiosk did not ask for leaves a trace**, because nothing on screen will [0348].
 *
 * `warn` for the ordinary causes — a network drop, a deploy, a refused upgrade, a removed device, a
 * candidate session the server could not record (`1011`) — and `error` for `1008`, which only happens if
 * this client sent a frame the gateway refused: one off the kiosk's list, or, since KAD-6j-e, a
 * `session.started` / `session.ended` it judged invalid. Either is a defect in this client, never an
 * operating condition. ⛔ Nothing identifying: no `kioskId`, no venue, no cookie, no name.
 */
export function reportClosed(code: number | undefined, rawReason: string, retryInMs: number): void {
  /*
   * The reason is the server's own constant (`candidate_session_unrecorded`, `kiosk_frame_invalid`, …), so it
   * tells a `1011` from a network drop. Capped all the same: it is text from the far side.
   */
  const reason = rawReason.slice(0, MAX_LOGGED_REASON);
  if (code === KIOSK_FRAME_REFUSED) {
    console.error({
      msg: 'the gateway closed the live socket because it refused a frame this kiosk sent — a type off the kiosk list, or a session frame it judged invalid',
      alert: 'live_socket_kiosk_sent_a_frame',
      code,
      reason,
      retryInMs,
    });
    return;
  }
  console.warn({
    msg: 'the live status socket closed while the kiosk was in front — reopening after a backoff',
    alert: 'live_socket_closed',
    code,
    reason,
    retryInMs,
  });
}
